var map = {
	"./AD.svg": 80565,
	"./AE.svg": 19284,
	"./AF.svg": 7143,
	"./AG.svg": 67606,
	"./AI.svg": 26576,
	"./AL.svg": 77213,
	"./AM.svg": 65020,
	"./AO.svg": 65118,
	"./AQ.svg": 17400,
	"./AR.svg": 56235,
	"./AS.svg": 50970,
	"./AT.svg": 85893,
	"./AU.svg": 7876,
	"./AW.svg": 49670,
	"./AX.svg": 47825,
	"./AZ.svg": 98003,
	"./BA.svg": 28721,
	"./BB.svg": 74178,
	"./BD.svg": 69132,
	"./BE.svg": 48845,
	"./BF.svg": 19726,
	"./BG.svg": 24479,
	"./BH.svg": 21592,
	"./BI.svg": 72809,
	"./BJ.svg": 57722,
	"./BL.svg": 14628,
	"./BM.svg": 69349,
	"./BN.svg": 70214,
	"./BO.svg": 41399,
	"./BQ.svg": 29217,
	"./BR.svg": 40530,
	"./BS.svg": 78467,
	"./BT.svg": 3836,
	"./BV.svg": 20286,
	"./BW.svg": 82863,
	"./BY.svg": 98009,
	"./BZ.svg": 37258,
	"./CA.svg": 88114,
	"./CC.svg": 64560,
	"./CD.svg": 30447,
	"./CF.svg": 22045,
	"./CG.svg": 51420,
	"./CH.svg": 2683,
	"./CI.svg": 84842,
	"./CK.svg": 21320,
	"./CL.svg": 41127,
	"./CM.svg": 54006,
	"./CN.svg": 11605,
	"./CO.svg": 69620,
	"./CR.svg": 76305,
	"./CU.svg": 67310,
	"./CV.svg": 96429,
	"./CW.svg": 16716,
	"./CX.svg": 24363,
	"./CY.svg": 5306,
	"./CZ.svg": 4041,
	"./DE.svg": 66895,
	"./DJ.svg": 51272,
	"./DK.svg": 47289,
	"./DM.svg": 53671,
	"./DO.svg": 27093,
	"./DZ.svg": 56600,
	"./EC.svg": 10062,
	"./EE.svg": 72608,
	"./EG.svg": 64514,
	"./EH.svg": 59685,
	"./ER.svg": 73199,
	"./ES.svg": 10622,
	"./ET.svg": 19553,
	"./EU.svg": 7312,
	"./FI.svg": 38509,
	"./FJ.svg": 90158,
	"./FK.svg": 18591,
	"./FM.svg": 88657,
	"./FO.svg": 73459,
	"./FR.svg": 35734,
	"./GA.svg": 83318,
	"./GB.svg": 55189,
	"./GD.svg": 8699,
	"./GE.svg": 48330,
	"./GF.svg": 39705,
	"./GG.svg": 57960,
	"./GH.svg": 24559,
	"./GI.svg": 80830,
	"./GL.svg": 15715,
	"./GM.svg": 1074,
	"./GN.svg": 94209,
	"./GP.svg": 52471,
	"./GQ.svg": 38086,
	"./GR.svg": 60517,
	"./GS.svg": 9348,
	"./GT.svg": 14027,
	"./GU.svg": 99418,
	"./GW.svg": 63288,
	"./GY.svg": 37742,
	"./HK.svg": 67549,
	"./HM.svg": 83011,
	"./HN.svg": 16912,
	"./HR.svg": 98212,
	"./HT.svg": 41306,
	"./HU.svg": 46571,
	"./ID.svg": 77757,
	"./IE.svg": 88284,
	"./IL.svg": 97941,
	"./IM.svg": 41684,
	"./IN.svg": 89895,
	"./IO.svg": 26070,
	"./IQ.svg": 43040,
	"./IR.svg": 63795,
	"./IS.svg": 58626,
	"./IT.svg": 28845,
	"./JE.svg": 1941,
	"./JM.svg": 12381,
	"./JO.svg": 20783,
	"./JP.svg": 59512,
	"./KE.svg": 92422,
	"./KG.svg": 50628,
	"./KH.svg": 40755,
	"./KI.svg": 10178,
	"./KM.svg": 25102,
	"./KN.svg": 19469,
	"./KP.svg": 93659,
	"./KR.svg": 94041,
	"./KW.svg": 78388,
	"./KY.svg": 86034,
	"./KZ.svg": 67777,
	"./LA.svg": 57451,
	"./LB.svg": 2264,
	"./LC.svg": 53481,
	"./LI.svg": 17491,
	"./LK.svg": 9393,
	"./LR.svg": 70760,
	"./LS.svg": 78681,
	"./LT.svg": 87094,
	"./LU.svg": 74215,
	"./LV.svg": 2708,
	"./LY.svg": 59139,
	"./MA.svg": 50292,
	"./MC.svg": 34678,
	"./MD.svg": 26265,
	"./ME.svg": 1992,
	"./MF.svg": 99707,
	"./MG.svg": 65514,
	"./MH.svg": 2717,
	"./MK.svg": 48542,
	"./ML.svg": 57473,
	"./MM.svg": 45232,
	"./MN.svg": 6723,
	"./MO.svg": 68786,
	"./MP.svg": 97605,
	"./MQ.svg": 42884,
	"./MR.svg": 69655,
	"./MS.svg": 98470,
	"./MT.svg": 84713,
	"./MU.svg": 49848,
	"./MV.svg": 5035,
	"./MW.svg": 85978,
	"./MX.svg": 77101,
	"./MY.svg": 97388,
	"./MZ.svg": 52735,
	"./NA.svg": 77901,
	"./NC.svg": 9567,
	"./NE.svg": 6481,
	"./NF.svg": 49378,
	"./NG.svg": 53107,
	"./NI.svg": 70725,
	"./NL.svg": 99352,
	"./NO.svg": 57419,
	"./NP.svg": 7324,
	"./NR.svg": 89598,
	"./NU.svg": 6977,
	"./NZ.svg": 33206,
	"./OM.svg": 88330,
	"./PA.svg": 57647,
	"./PE.svg": 48803,
	"./PF.svg": 91760,
	"./PG.svg": 27297,
	"./PH.svg": 16406,
	"./PK.svg": 88277,
	"./PL.svg": 81418,
	"./PM.svg": 41787,
	"./PN.svg": 91048,
	"./PR.svg": 20236,
	"./PS.svg": 19181,
	"./PT.svg": 48962,
	"./PW.svg": 69329,
	"./PY.svg": 85559,
	"./QA.svg": 89688,
	"./RE.svg": 10301,
	"./RO.svg": 40231,
	"./RS.svg": 31091,
	"./RU.svg": 9805,
	"./RW.svg": 53375,
	"./SA.svg": 1378,
	"./SB.svg": 21745,
	"./SC.svg": 85792,
	"./SD.svg": 51679,
	"./SE.svg": 23246,
	"./SG.svg": 72652,
	"./SH.svg": 99531,
	"./SI.svg": 84922,
	"./SJ.svg": 53033,
	"./SK.svg": 48792,
	"./SL.svg": 37975,
	"./SM.svg": 23590,
	"./SN.svg": 46021,
	"./SO.svg": 94852,
	"./SR.svg": 79713,
	"./SS.svg": 44176,
	"./ST.svg": 10063,
	"./SV.svg": 20509,
	"./SX.svg": 94203,
	"./SY.svg": 33834,
	"./SZ.svg": 25209,
	"./TC.svg": 23665,
	"./TD.svg": 58190,
	"./TF.svg": 17100,
	"./TG.svg": 68909,
	"./TH.svg": 26810,
	"./TJ.svg": 93240,
	"./TK.svg": 68745,
	"./TL.svg": 25510,
	"./TM.svg": 88311,
	"./TN.svg": 83716,
	"./TO.svg": 61733,
	"./TR.svg": 2416,
	"./TT.svg": 40958,
	"./TV.svg": 40860,
	"./TW.svg": 53053,
	"./TZ.svg": 45384,
	"./UA.svg": 88444,
	"./UG.svg": 66706,
	"./UM.svg": 92968,
	"./US.svg": 5774,
	"./UY.svg": 31300,
	"./UZ.svg": 35895,
	"./VA.svg": 7765,
	"./VC.svg": 34343,
	"./VE.svg": 27961,
	"./VG.svg": 47483,
	"./VI.svg": 73789,
	"./VN.svg": 39858,
	"./VU.svg": 46281,
	"./WF.svg": 43817,
	"./WS.svg": 93044,
	"./XK.svg": 58573,
	"./YE.svg": 82892,
	"./YT.svg": 88221,
	"./ZA.svg": 43369,
	"./ZM.svg": 61933,
	"./ZW.svg": 22983,
	"@pano-project/assets/icons/flags/AD.svg": 80565,
	"@pano-project/assets/icons/flags/AE.svg": 19284,
	"@pano-project/assets/icons/flags/AF.svg": 7143,
	"@pano-project/assets/icons/flags/AG.svg": 67606,
	"@pano-project/assets/icons/flags/AI.svg": 26576,
	"@pano-project/assets/icons/flags/AL.svg": 77213,
	"@pano-project/assets/icons/flags/AM.svg": 65020,
	"@pano-project/assets/icons/flags/AO.svg": 65118,
	"@pano-project/assets/icons/flags/AQ.svg": 17400,
	"@pano-project/assets/icons/flags/AR.svg": 56235,
	"@pano-project/assets/icons/flags/AS.svg": 50970,
	"@pano-project/assets/icons/flags/AT.svg": 85893,
	"@pano-project/assets/icons/flags/AU.svg": 7876,
	"@pano-project/assets/icons/flags/AW.svg": 49670,
	"@pano-project/assets/icons/flags/AX.svg": 47825,
	"@pano-project/assets/icons/flags/AZ.svg": 98003,
	"@pano-project/assets/icons/flags/BA.svg": 28721,
	"@pano-project/assets/icons/flags/BB.svg": 74178,
	"@pano-project/assets/icons/flags/BD.svg": 69132,
	"@pano-project/assets/icons/flags/BE.svg": 48845,
	"@pano-project/assets/icons/flags/BF.svg": 19726,
	"@pano-project/assets/icons/flags/BG.svg": 24479,
	"@pano-project/assets/icons/flags/BH.svg": 21592,
	"@pano-project/assets/icons/flags/BI.svg": 72809,
	"@pano-project/assets/icons/flags/BJ.svg": 57722,
	"@pano-project/assets/icons/flags/BL.svg": 14628,
	"@pano-project/assets/icons/flags/BM.svg": 69349,
	"@pano-project/assets/icons/flags/BN.svg": 70214,
	"@pano-project/assets/icons/flags/BO.svg": 41399,
	"@pano-project/assets/icons/flags/BQ.svg": 29217,
	"@pano-project/assets/icons/flags/BR.svg": 40530,
	"@pano-project/assets/icons/flags/BS.svg": 78467,
	"@pano-project/assets/icons/flags/BT.svg": 3836,
	"@pano-project/assets/icons/flags/BV.svg": 20286,
	"@pano-project/assets/icons/flags/BW.svg": 82863,
	"@pano-project/assets/icons/flags/BY.svg": 98009,
	"@pano-project/assets/icons/flags/BZ.svg": 37258,
	"@pano-project/assets/icons/flags/CA.svg": 88114,
	"@pano-project/assets/icons/flags/CC.svg": 64560,
	"@pano-project/assets/icons/flags/CD.svg": 30447,
	"@pano-project/assets/icons/flags/CF.svg": 22045,
	"@pano-project/assets/icons/flags/CG.svg": 51420,
	"@pano-project/assets/icons/flags/CH.svg": 2683,
	"@pano-project/assets/icons/flags/CI.svg": 84842,
	"@pano-project/assets/icons/flags/CK.svg": 21320,
	"@pano-project/assets/icons/flags/CL.svg": 41127,
	"@pano-project/assets/icons/flags/CM.svg": 54006,
	"@pano-project/assets/icons/flags/CN.svg": 11605,
	"@pano-project/assets/icons/flags/CO.svg": 69620,
	"@pano-project/assets/icons/flags/CR.svg": 76305,
	"@pano-project/assets/icons/flags/CU.svg": 67310,
	"@pano-project/assets/icons/flags/CV.svg": 96429,
	"@pano-project/assets/icons/flags/CW.svg": 16716,
	"@pano-project/assets/icons/flags/CX.svg": 24363,
	"@pano-project/assets/icons/flags/CY.svg": 5306,
	"@pano-project/assets/icons/flags/CZ.svg": 4041,
	"@pano-project/assets/icons/flags/DE.svg": 66895,
	"@pano-project/assets/icons/flags/DJ.svg": 51272,
	"@pano-project/assets/icons/flags/DK.svg": 47289,
	"@pano-project/assets/icons/flags/DM.svg": 53671,
	"@pano-project/assets/icons/flags/DO.svg": 27093,
	"@pano-project/assets/icons/flags/DZ.svg": 56600,
	"@pano-project/assets/icons/flags/EC.svg": 10062,
	"@pano-project/assets/icons/flags/EE.svg": 72608,
	"@pano-project/assets/icons/flags/EG.svg": 64514,
	"@pano-project/assets/icons/flags/EH.svg": 59685,
	"@pano-project/assets/icons/flags/ER.svg": 73199,
	"@pano-project/assets/icons/flags/ES.svg": 10622,
	"@pano-project/assets/icons/flags/ET.svg": 19553,
	"@pano-project/assets/icons/flags/EU.svg": 7312,
	"@pano-project/assets/icons/flags/FI.svg": 38509,
	"@pano-project/assets/icons/flags/FJ.svg": 90158,
	"@pano-project/assets/icons/flags/FK.svg": 18591,
	"@pano-project/assets/icons/flags/FM.svg": 88657,
	"@pano-project/assets/icons/flags/FO.svg": 73459,
	"@pano-project/assets/icons/flags/FR.svg": 35734,
	"@pano-project/assets/icons/flags/GA.svg": 83318,
	"@pano-project/assets/icons/flags/GB.svg": 55189,
	"@pano-project/assets/icons/flags/GD.svg": 8699,
	"@pano-project/assets/icons/flags/GE.svg": 48330,
	"@pano-project/assets/icons/flags/GF.svg": 39705,
	"@pano-project/assets/icons/flags/GG.svg": 57960,
	"@pano-project/assets/icons/flags/GH.svg": 24559,
	"@pano-project/assets/icons/flags/GI.svg": 80830,
	"@pano-project/assets/icons/flags/GL.svg": 15715,
	"@pano-project/assets/icons/flags/GM.svg": 1074,
	"@pano-project/assets/icons/flags/GN.svg": 94209,
	"@pano-project/assets/icons/flags/GP.svg": 52471,
	"@pano-project/assets/icons/flags/GQ.svg": 38086,
	"@pano-project/assets/icons/flags/GR.svg": 60517,
	"@pano-project/assets/icons/flags/GS.svg": 9348,
	"@pano-project/assets/icons/flags/GT.svg": 14027,
	"@pano-project/assets/icons/flags/GU.svg": 99418,
	"@pano-project/assets/icons/flags/GW.svg": 63288,
	"@pano-project/assets/icons/flags/GY.svg": 37742,
	"@pano-project/assets/icons/flags/HK.svg": 67549,
	"@pano-project/assets/icons/flags/HM.svg": 83011,
	"@pano-project/assets/icons/flags/HN.svg": 16912,
	"@pano-project/assets/icons/flags/HR.svg": 98212,
	"@pano-project/assets/icons/flags/HT.svg": 41306,
	"@pano-project/assets/icons/flags/HU.svg": 46571,
	"@pano-project/assets/icons/flags/ID.svg": 77757,
	"@pano-project/assets/icons/flags/IE.svg": 88284,
	"@pano-project/assets/icons/flags/IL.svg": 97941,
	"@pano-project/assets/icons/flags/IM.svg": 41684,
	"@pano-project/assets/icons/flags/IN.svg": 89895,
	"@pano-project/assets/icons/flags/IO.svg": 26070,
	"@pano-project/assets/icons/flags/IQ.svg": 43040,
	"@pano-project/assets/icons/flags/IR.svg": 63795,
	"@pano-project/assets/icons/flags/IS.svg": 58626,
	"@pano-project/assets/icons/flags/IT.svg": 28845,
	"@pano-project/assets/icons/flags/JE.svg": 1941,
	"@pano-project/assets/icons/flags/JM.svg": 12381,
	"@pano-project/assets/icons/flags/JO.svg": 20783,
	"@pano-project/assets/icons/flags/JP.svg": 59512,
	"@pano-project/assets/icons/flags/KE.svg": 92422,
	"@pano-project/assets/icons/flags/KG.svg": 50628,
	"@pano-project/assets/icons/flags/KH.svg": 40755,
	"@pano-project/assets/icons/flags/KI.svg": 10178,
	"@pano-project/assets/icons/flags/KM.svg": 25102,
	"@pano-project/assets/icons/flags/KN.svg": 19469,
	"@pano-project/assets/icons/flags/KP.svg": 93659,
	"@pano-project/assets/icons/flags/KR.svg": 94041,
	"@pano-project/assets/icons/flags/KW.svg": 78388,
	"@pano-project/assets/icons/flags/KY.svg": 86034,
	"@pano-project/assets/icons/flags/KZ.svg": 67777,
	"@pano-project/assets/icons/flags/LA.svg": 57451,
	"@pano-project/assets/icons/flags/LB.svg": 2264,
	"@pano-project/assets/icons/flags/LC.svg": 53481,
	"@pano-project/assets/icons/flags/LI.svg": 17491,
	"@pano-project/assets/icons/flags/LK.svg": 9393,
	"@pano-project/assets/icons/flags/LR.svg": 70760,
	"@pano-project/assets/icons/flags/LS.svg": 78681,
	"@pano-project/assets/icons/flags/LT.svg": 87094,
	"@pano-project/assets/icons/flags/LU.svg": 74215,
	"@pano-project/assets/icons/flags/LV.svg": 2708,
	"@pano-project/assets/icons/flags/LY.svg": 59139,
	"@pano-project/assets/icons/flags/MA.svg": 50292,
	"@pano-project/assets/icons/flags/MC.svg": 34678,
	"@pano-project/assets/icons/flags/MD.svg": 26265,
	"@pano-project/assets/icons/flags/ME.svg": 1992,
	"@pano-project/assets/icons/flags/MF.svg": 99707,
	"@pano-project/assets/icons/flags/MG.svg": 65514,
	"@pano-project/assets/icons/flags/MH.svg": 2717,
	"@pano-project/assets/icons/flags/MK.svg": 48542,
	"@pano-project/assets/icons/flags/ML.svg": 57473,
	"@pano-project/assets/icons/flags/MM.svg": 45232,
	"@pano-project/assets/icons/flags/MN.svg": 6723,
	"@pano-project/assets/icons/flags/MO.svg": 68786,
	"@pano-project/assets/icons/flags/MP.svg": 97605,
	"@pano-project/assets/icons/flags/MQ.svg": 42884,
	"@pano-project/assets/icons/flags/MR.svg": 69655,
	"@pano-project/assets/icons/flags/MS.svg": 98470,
	"@pano-project/assets/icons/flags/MT.svg": 84713,
	"@pano-project/assets/icons/flags/MU.svg": 49848,
	"@pano-project/assets/icons/flags/MV.svg": 5035,
	"@pano-project/assets/icons/flags/MW.svg": 85978,
	"@pano-project/assets/icons/flags/MX.svg": 77101,
	"@pano-project/assets/icons/flags/MY.svg": 97388,
	"@pano-project/assets/icons/flags/MZ.svg": 52735,
	"@pano-project/assets/icons/flags/NA.svg": 77901,
	"@pano-project/assets/icons/flags/NC.svg": 9567,
	"@pano-project/assets/icons/flags/NE.svg": 6481,
	"@pano-project/assets/icons/flags/NF.svg": 49378,
	"@pano-project/assets/icons/flags/NG.svg": 53107,
	"@pano-project/assets/icons/flags/NI.svg": 70725,
	"@pano-project/assets/icons/flags/NL.svg": 99352,
	"@pano-project/assets/icons/flags/NO.svg": 57419,
	"@pano-project/assets/icons/flags/NP.svg": 7324,
	"@pano-project/assets/icons/flags/NR.svg": 89598,
	"@pano-project/assets/icons/flags/NU.svg": 6977,
	"@pano-project/assets/icons/flags/NZ.svg": 33206,
	"@pano-project/assets/icons/flags/OM.svg": 88330,
	"@pano-project/assets/icons/flags/PA.svg": 57647,
	"@pano-project/assets/icons/flags/PE.svg": 48803,
	"@pano-project/assets/icons/flags/PF.svg": 91760,
	"@pano-project/assets/icons/flags/PG.svg": 27297,
	"@pano-project/assets/icons/flags/PH.svg": 16406,
	"@pano-project/assets/icons/flags/PK.svg": 88277,
	"@pano-project/assets/icons/flags/PL.svg": 81418,
	"@pano-project/assets/icons/flags/PM.svg": 41787,
	"@pano-project/assets/icons/flags/PN.svg": 91048,
	"@pano-project/assets/icons/flags/PR.svg": 20236,
	"@pano-project/assets/icons/flags/PS.svg": 19181,
	"@pano-project/assets/icons/flags/PT.svg": 48962,
	"@pano-project/assets/icons/flags/PW.svg": 69329,
	"@pano-project/assets/icons/flags/PY.svg": 85559,
	"@pano-project/assets/icons/flags/QA.svg": 89688,
	"@pano-project/assets/icons/flags/RE.svg": 10301,
	"@pano-project/assets/icons/flags/RO.svg": 40231,
	"@pano-project/assets/icons/flags/RS.svg": 31091,
	"@pano-project/assets/icons/flags/RU.svg": 9805,
	"@pano-project/assets/icons/flags/RW.svg": 53375,
	"@pano-project/assets/icons/flags/SA.svg": 1378,
	"@pano-project/assets/icons/flags/SB.svg": 21745,
	"@pano-project/assets/icons/flags/SC.svg": 85792,
	"@pano-project/assets/icons/flags/SD.svg": 51679,
	"@pano-project/assets/icons/flags/SE.svg": 23246,
	"@pano-project/assets/icons/flags/SG.svg": 72652,
	"@pano-project/assets/icons/flags/SH.svg": 99531,
	"@pano-project/assets/icons/flags/SI.svg": 84922,
	"@pano-project/assets/icons/flags/SJ.svg": 53033,
	"@pano-project/assets/icons/flags/SK.svg": 48792,
	"@pano-project/assets/icons/flags/SL.svg": 37975,
	"@pano-project/assets/icons/flags/SM.svg": 23590,
	"@pano-project/assets/icons/flags/SN.svg": 46021,
	"@pano-project/assets/icons/flags/SO.svg": 94852,
	"@pano-project/assets/icons/flags/SR.svg": 79713,
	"@pano-project/assets/icons/flags/SS.svg": 44176,
	"@pano-project/assets/icons/flags/ST.svg": 10063,
	"@pano-project/assets/icons/flags/SV.svg": 20509,
	"@pano-project/assets/icons/flags/SX.svg": 94203,
	"@pano-project/assets/icons/flags/SY.svg": 33834,
	"@pano-project/assets/icons/flags/SZ.svg": 25209,
	"@pano-project/assets/icons/flags/TC.svg": 23665,
	"@pano-project/assets/icons/flags/TD.svg": 58190,
	"@pano-project/assets/icons/flags/TF.svg": 17100,
	"@pano-project/assets/icons/flags/TG.svg": 68909,
	"@pano-project/assets/icons/flags/TH.svg": 26810,
	"@pano-project/assets/icons/flags/TJ.svg": 93240,
	"@pano-project/assets/icons/flags/TK.svg": 68745,
	"@pano-project/assets/icons/flags/TL.svg": 25510,
	"@pano-project/assets/icons/flags/TM.svg": 88311,
	"@pano-project/assets/icons/flags/TN.svg": 83716,
	"@pano-project/assets/icons/flags/TO.svg": 61733,
	"@pano-project/assets/icons/flags/TR.svg": 2416,
	"@pano-project/assets/icons/flags/TT.svg": 40958,
	"@pano-project/assets/icons/flags/TV.svg": 40860,
	"@pano-project/assets/icons/flags/TW.svg": 53053,
	"@pano-project/assets/icons/flags/TZ.svg": 45384,
	"@pano-project/assets/icons/flags/UA.svg": 88444,
	"@pano-project/assets/icons/flags/UG.svg": 66706,
	"@pano-project/assets/icons/flags/UM.svg": 92968,
	"@pano-project/assets/icons/flags/US.svg": 5774,
	"@pano-project/assets/icons/flags/UY.svg": 31300,
	"@pano-project/assets/icons/flags/UZ.svg": 35895,
	"@pano-project/assets/icons/flags/VA.svg": 7765,
	"@pano-project/assets/icons/flags/VC.svg": 34343,
	"@pano-project/assets/icons/flags/VE.svg": 27961,
	"@pano-project/assets/icons/flags/VG.svg": 47483,
	"@pano-project/assets/icons/flags/VI.svg": 73789,
	"@pano-project/assets/icons/flags/VN.svg": 39858,
	"@pano-project/assets/icons/flags/VU.svg": 46281,
	"@pano-project/assets/icons/flags/WF.svg": 43817,
	"@pano-project/assets/icons/flags/WS.svg": 93044,
	"@pano-project/assets/icons/flags/XK.svg": 58573,
	"@pano-project/assets/icons/flags/YE.svg": 82892,
	"@pano-project/assets/icons/flags/YT.svg": 88221,
	"@pano-project/assets/icons/flags/ZA.svg": 43369,
	"@pano-project/assets/icons/flags/ZM.svg": 61933,
	"@pano-project/assets/icons/flags/ZW.svg": 22983
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73374;